import { render, staticRenderFns } from "./Ventas.vue?vue&type=template&id=32417b83&scoped=true&"
import script from "./Ventas.vue?vue&type=script&lang=js&"
export * from "./Ventas.vue?vue&type=script&lang=js&"
import style0 from "./Ventas.vue?vue&type=style&index=0&id=32417b83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32417b83",
  null
  
)

export default component.exports